export default __webpack_public_path__ + "media/images/gps-6ae0b577172af8d5aa34dee77f98ae6b.svg";